import { render, staticRenderFns } from "./DialogProductCategorieDelete.vue?vue&type=template&id=ec1679ec&"
import script from "./DialogProductCategorieDelete.vue?vue&type=script&lang=js&"
export * from "./DialogProductCategorieDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports